import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/Button/Button'

import { clearHistoryMode, selectIsHistoryMode } from '../../../store/meetingSummary/contactUpdate'
import { displayDocumentSidebar } from '../../../store/processDocument/documentSidebar'
import { selectDocumentBatchDocuments, selectDocumentBatchHasMultipleDocuments } from '../../../store/processDocument/documentBatch'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { DocumentSidebarType, DocumentSidebarTitle } from '../DocumentSidebar/models'

export const DocumentHeader = () => {
  const dispatch = useAppDispatch()

  const navigate = useNavigate()

  const isHistoryMode = useAppSelector(selectIsHistoryMode)
  const batchDocuments = useAppSelector(selectDocumentBatchDocuments)
  const hasMultipleDocuments = useAppSelector(selectDocumentBatchHasMultipleDocuments)

  const handleBackToDocumentsButtonClicked = () => {
    navigate(`/document-batches/${batchDocuments[0].documentBatchId}`)
  }

  const handleBackButtonClicked = () => {
    navigate('/documents/upload')
  }

  const handleBackButtonClickedInHistoryMode = () => {
    dispatch(clearHistoryMode())
    dispatch(displayDocumentSidebar({ type: DocumentSidebarType.EXTERNAL_UPDATES, title: DocumentSidebarTitle.EXTERNAL_UPDATES, icon: 'bi-arrow-repeat' }))
  }

  return (
    <div className='d-flex zocks-pl-2.0 justify-content-between align-items-center'>
      {isHistoryMode ? (
        <Button variant='header' className='zocks-p-0.625' onClick={handleBackButtonClickedInHistoryMode}>
          <i className='bi bi-chevron-left' />
        </Button>
      ) : !hasMultipleDocuments ? (
        <Button variant='header' className='zocks-p-0.625' onClick={handleBackButtonClicked}>
          <i className='bi bi-chevron-left' />
        </Button>
      ) : (
        <div className='d-flex align-items-center gap-2'>
          <Button variant='header' className='zocks-p-0.625' onClick={handleBackToDocumentsButtonClicked}>
            <i className='bi bi-chevron-left' />
          </Button>
          <span className='paragraph-medium bold'>Back to documents</span>
        </div>
      )}
    </div>
  )
}
